import { render, staticRenderFns } from "./WattageDetail.vue?vue&type=template&id=aa084a66&scoped=true"
import script from "./WattageDetail.vue?vue&type=script&lang=js"
export * from "./WattageDetail.vue?vue&type=script&lang=js"
import style0 from "./WattageDetail.vue?vue&type=style&index=0&id=aa084a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa084a66",
  null
  
)

export default component.exports